import React from "react";
import "../assets/css/style.css";

const Spinner = ({ size = 40, color = "#98272A" }) => (
  <div className="spinner-backdrop">
    <div
      className="spinner"
      style={{
        width: size,
        height: size,
        borderColor: `${color} transparent ${color} transparent`,
      }}
    ></div>
  </div>
);

export default Spinner;
